import React, {Component} from 'react';
import {Input,Form} from "antd";

class NormalInput extends Component {

    static defaultProps = {
        maxLength: 300
    };

    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }


    render() {
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <Input maxLength={this.props.maxLength} placeholder={"请输入"} className={"normalInput"} value={this.props.itemValue} style={{width:"266px"}} onChange={(e)=>{
                    this.props.callBack && this.props.callBack(e.target.value)
                }}/>
                <style>{`.normalInput{background: rgba(0, 80, 179, 0.04);border: "1px solid rgba(0, 80, 179, 0.08)}`}</style>
            </Form.Item>
        );
    }
}

export default NormalInput;
